import { useContext } from 'react'
import { DrawerContext } from '@/root/shared-providers'

export const useDrawer = () => {
  return useContext(DrawerContext)
}
